import React from "react";

export default function ErrorMessage({ error, visible, customStyle }) {
    if (!visible || !error) return null;

    return <p className={customStyle}>{error}</p>;
}
